import { api } from 'redux/api/index.api';
import { quality as qualityEnum } from 'utils/constants';
import { downloadFile, getFilename } from 'utils/file';

export const mediaServiceApi = api.injectEndpoints({
  endpoints: builder => ({
    download: builder.query({
      query: ({ url, mediaId }) => ({
        method: 'GET',
        url: `${url || `medias/${mediaId}`}/download`,
        responseHandler: response => response.blob(),
      }),
      async onQueryStarted({ fileName, mimeType }, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (data) {
            const blob = data instanceof Blob ? data : new Blob(data);
            const fakeUrl = window.URL.createObjectURL(blob);
            downloadFile(fakeUrl, getFilename(fileName, mimeType));
          }
        } catch (error) {
          console.error('Error downloading media:', error);
        }
      },
    }),
    getImageUrl: builder.query({
      async queryFn({ url, quality = qualityEnum.original }, _queryApi, _extraOptions, baseQuery) {
        const result = await baseQuery({
          url: `${url}/url`,
          params: { quality, _: new Date().getTime() },
        });

        if (result.data?.media_url && (result.data?.width || quality === qualityEnum.original)) {
          return { data: result.data.media_url };
        }

        const fallback = await baseQuery({
          url: `${url}/url`,
          params: { quality: qualityEnum.thumbnail, _: new Date().getTime() },
        });

        if (fallback.error) return fallback;

        if (fallback.data?.media_url) {
          return { data: fallback.data.media_url };
        }

        return { data: null };
      },
    }),
  }),
  overrideExisting: 'throw',
});

export const { useLazyDownloadQuery, useGetImageUrlQuery } = mediaServiceApi;
